var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "#7F7F7F",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.024 8a3.7 3.7 0 0 1-2.169-.668l-5.542 2.682 5.301 2.777c.723-.497 1.567-.79 2.41-.79C18.193 12 20 13.79 20 16S18.193 20 16.024 20s-3.976-1.79-3.976-4c0-.574.12-1.121.362-1.615l-4.82-2.49C6.867 13.15 5.542 14 3.976 14 1.807 14 0 12.21 0 10s1.807-4 3.976-4c1.566 0 2.891.863 3.614 2.13l4.82-2.357A4.3 4.3 0 0 1 12.048 4c0-2.209 1.807-4 3.976-4S20 1.791 20 4s-1.807 4-3.976 4m0-6c-1.084 0-2.048.896-2.048 2s.964 2 2.048 2 2.048-.895 2.048-2-.964-2-2.048-2M3.976 8c-1.084 0-1.928.896-1.928 2s.844 2 1.928 2c1.205 0 2.048-.896 2.048-2s-.843-2-2.048-2m10 8c0-1.104.964-2 2.048-2s2.048.896 2.048 2-.964 2-2.048 2-2.048-.895-2.048-2",
    clipRule: "evenodd"
  })));
};
export default SvgIconShare;